export default "__VITE_ASSET__DhxqYl7i__"